import React from 'react'

const Icon = ({ src, size = 18, className = '', otherProps = {} }) => (
  <img
    src={src}
    width={size}
    height={size}
    alt=""
    className={`formz-icon-img ${className}`}
    {...otherProps}
  />
)

export default Icon
